import { getLocalstorage } from './utils'

// 获取本地存储的用户信息
export const getUserInfo = () => {
  return getLocalstorage('userinfo')
}

export const sortFn = (filed) => {
  return (a, b) => {
    const an = Number(a[filed])
    const bn = Number(b[filed])
    if(an > bn) {
      return 1
    }
    if(an < bn) {
      return -1
    }
    return 0
  }
}

export const stopPropagation = (e) => {
  e.stopPropagation()
}
